import type { CheckboxData, Data, Options } from './types';

export const mapDataToOptions = (data: CheckboxData): Options =>
	data.map(({ id, value }) => ({ label: value, value: id }));

export const mapOptionsToData = (options: Options): CheckboxData =>
	options.map(({ label, value }) => ({ id: value, value: label }));

export const setRetainValue = ({ options, itemValue, values }: Data): Options => {
	const selectedOption = options?.find((option) => option.value === itemValue);
	let retainValue = [...(values || [])];
	let isElementAlreadyChecked = false;
	const newCheckedItems = values?.filter((item) => {
		if (item.value === itemValue) isElementAlreadyChecked = true;
		return item.value !== itemValue;
	});
	if (isElementAlreadyChecked && newCheckedItems !== undefined) {
		retainValue = newCheckedItems;
	} else if (selectedOption) {
		retainValue.push(selectedOption);
	}
	return retainValue;
};
